export default {
    HTTP_BAD_REQUEST: 400,
    HTTP_NOT_FOUND: 404,
    HTTP_FORBIDDEN: 403,
    HTTP_SERVICE_UNAVAILABLE: 503,
};
